import store from '@/store'
import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js'
import { countryCallingCodeConfig } from '@/config'

export default {
  getCountryCallingCodeList() {
    return store.getters['Common/getCountryCallingCodeListFromState']
  },
  findCountryCallingCode(id) {
    const list = this.getCountryCallingCodeList()
    return list.find((ele) => Number(ele.countryId) === Number(id))
  },
  getJpCountryCallingCodeSelectBoxInfo() {
    const jp = '81'
    const ret = this.findCountryCallingCode(jp)
    return ret
      ? { label: '+' + ret.code, value: ret.countryId }
      : { label: '', value: null }
  },

  getPhoneNumberCountryIdInfo(code) {
    const list = this.findCountryCallingCode(code)

    return list
      ? { label: '+' + list.code, value: list.countryId }
      : { label: '', value: null }
  },
  findCountryCallingId(id) {
    const list = this.getCountryCallingCodeList()
    return list.find((ele) => Number(ele.countryId) === id)
  },

  getPhoneNumberInfoById(id) {
    const list = this.findCountryCallingId(id)

    return list
      ? { label: '+' + list.code, value: list.countryId }
      : { label: '', value: null }
  },
  formatPhoneNumber(phone = '', id = '', isDisplayCode = true) {
    if (phone && !id) {
      return phone
    }
    if (!phone || !id) {
      return ''
    }

    const code = this.findCountryCallingId(id).code
    const intlCode = '+' + code
    const defaultPhoneInfo = (isDisplayCode ? intlCode : '') + phone

    // 国コード確認と電話番号の有効性確認
    if (
      code != countryCallingCodeConfig.COUNTRY_CALLING_CODE_LIST.JPN ||
      !parsePhoneNumberFromString(intlCode + phone, 'JA')
    ) {
      return defaultPhoneInfo
    }

    // フォーマット
    const formatPhoneNum = new AsYouType('JP').input(phone)
    if (!RegExp('-').test(formatPhoneNum)) {
      // 国際電話（010xxxxxxxxx）などフォーマットできないケース
      return defaultPhoneInfo
    }

    return (isDisplayCode ? intlCode + '-' : '') + formatPhoneNum
  }
}
